import React from 'react'
import { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import {  Bar } from 'react-chartjs-2';
import API from '../utils/api.js'
import { formatearNumero } from '../utils/FormatearNumero.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);



const data_inicio_bar = {
  labels: ['Sin resultados'],
  datasets: [
    {
      label: 'Gastos Mensuales',
      data: [0],
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

const InformeGastos = () => {

  const [totalSum, setTotalSum] = useState(0);
  const [dataBar, setDataBar] = useState(data_inicio_bar)
  
  var url = API.urlAPI
  const urlGastosMes = url + "gastos/GastoMes"

  const optionsBar = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  const fetchDataBarra = async() => {
    let resp = await fetch(urlGastosMes)
    let dataBarra = await resp.json()
    const total = dataBarra.reduce((acc, row) => acc + parseFloat(row.Monto), 0);
    setTotalSum(total)

  let modeloBar = {
    labels: dataBarra.map((data) => data.Mes),
    datasets: [
      {
        label: 'Gasto por mes',
        data: dataBarra.map((data) => data.Monto),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ]
  };
  setDataBar(modeloBar)

  }


  
  useEffect(() => {
    fetchDataBarra()
  }, [])

  return (
    <>
          <br></br>
     <div className="row justify-content-center">

           <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Total Gastos</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">${formatearNumero(Number(totalSum))}</div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-shopping-basket fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="row justify-content-center">
    <div className="col-xl-4 col-lg-5 " >
          <div className="card shadow mb-4 justi">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-center bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Gastos por mes</h6>
            </div>
            <div className="row justify-content-center">
            <div className="card-body " >
              <div style={{ height: 300 }} >
                <Bar options={optionsBar} data={dataBar} />
              </div>

            </div>
          </div>
        </div>
</div>
</div>
    </>
  )
}

export default InformeGastos